import React from "react";
import "./TestimonialsSection.css";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Rajesh Kumar",
    location: "Velachery",
    text: "Best credit card swiping service in Chennai! Got cash in just 3 minutes. The rates are unbeatable at 1.79%.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    location: "Thiruvanmiyur",
    text: "Very professional and trustworthy. I've been using their services for over 2 years now. Highly recommended!",
    rating: 5,
  },
  {
    name: "Suresh Babu",
    location: "Pallavaram",
    text: "Instant transfer, no hidden charges. The team is very polite and helpful. 100% genuine service.",
    rating: 5,
  },
  {
    name: "Anitha Rajan",
    location: "Anna Nagar",
    text: "They also pay my credit card bills on time. One-stop solution for all my credit card needs. Amazing service!",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        
        <div className="testimonials-header fade-in-up">
          <h2 className="testimonials-title orange-gradient-text">
            What Our Customers Say
          </h2>
          <p className="testimonials-subtitle">
            Trusted by 10,000+ happy customers across Chennai
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div 
              key={t.name} 
              className="testimonial-card fade-in-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <Quote className="quote-icon" size={32} />
              <p className="testimonial-text">"{t.text}"</p>
              
              <div className="rating-stars">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="star-icon" size={16} />
                ))}
              </div>

              <div className="customer-info">
                <p className="customer-name">{t.name}</p>
                <p className="customer-location">{t.location}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;